import { render, staticRenderFns } from "./MotoboySender.vue?vue&type=template&id=0e2b90a8"
import script from "./MotoboySender.vue?vue&type=script&lang=js"
export * from "./MotoboySender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports